module.exports = __webpack_public_path__ + "img/logo-2.252dad60.webp";